import styled from 'styled-components';

export const Logo = styled.svg`
  margin: 0.625rem 0.75rem 0;
  height: 1.75rem;
  width: 7rem;
`;
